<template>
    <div class="w-100 bg-white ticket-box my-2">
        <b-overlay :show="progressing" class="h-100" rounded="sm" style="position:relative">
            <div @click="headerClicked()" 
                :class="setTicketHeaderClass(value.Items, value.RemainMin, value.OrderTypeID, value.OrderStatusID)"
                class="ticket-header sticky-footer d-flex flex-column aling-content-between justify-content-between font-weight-bold p-2">
                <div class="d-flex flex-row justify-content-between" style="font-size: 1rem;">
                    <span>{{value.TabNo}}<span v-if="value.TableNumber && value.OrderTypeID === 2">-{{value.TableNumber}}</span>
                    </span>

                    <div v-if="ticketType === 'complete' && (value.OrderStatusID === 1 || value.OrderStatusID === 2)" class="text-center">
                      Partially Prepared 
                    </div>

                    
                    <div class="text-center" style="font-size: 1rem;" v-if="value.OrderStatusID == '1' || value.OrderStatusID == 1">
                        NOT CONFIRMED
                    </div>
                    <div class="text-center" style="font-size: 1rem;" v-if="value.OrderStatusID == '2' || value.OrderStatusID == 2">
                        CONFIRMED 
                    </div>
                    <div class="text-center" style="font-size: 1rem;" v-if="value.OrderStatusID == '3' || value.OrderStatusID == 3">
                        READY
                    </div>
                    <div class="text-center" style="font-size: 1rem;" v-if="value.OrderStatusID == '4' || value.OrderStatusID == 4">
                       SERVED
                    </div>
                    <div class="text-center" style="font-size: 1rem;" v-if="value.OrderStatusID == '5' || value.OrderStatusID == 5">
                       CANCELED
                    </div>
                    <div class="text-center" style="margin-left:-2rem; font-size: 1rem;"
                       v-if="setTicketHeaderClass(value.Items, value.RemainMin, value.OrderTypeID, value.OrderStatusID) === 'danger-header text-white' && value.OrderTypeID !== 2">
                      <span v-if="value.RemainMin" class="mx-1">
                          (+{{Math.abs(value.RemainMin)}} Min
                      </span>
                      LATE)
                    </div>
                    <span v-if="value.RemainMin !='' " class="font-weight-normal" style="font-size: 1rem;">{{"+" +value.RemainMin + " Min"}}</span>
                    <span v-else class="font-weight-normal" style="width:2rem"></span>
                </div>





                <div class="text-center font-weight-normal " v-if="value.ServerName && value.OrderTypeID ==2 && !progressing">
                    Server: {{value.ServerName}}
                </div>
                <div class="text-center font-weight-normal" v-if="progressing">
                    <b-spinner  label="Spinning" class="loading-header"></b-spinner>

                </div>



                <div class="small d-flex flex-row justify-content-between font-weight-bold " >
                    <span style="font-size: 1.1rem; background-color: white; padding: 0.15rem 0.5rem; border-radius: 0.5rem; color: black;" >{{value.CustomerName}}
                      <span v-if="value.OrderID == value.OriginalOrderID">(Party 1)</span>
                    </span>
                    <div style="font-weight:bold; font-size:0.9rem; left:40%" class="text-cetner">{{value.OrderType}} <span v-if="value.PackagingType != '' && value.PackagingType != null">{{ ' (' + value.PackagingType + ')'}}</span></div>
                    <span v-if="value.OrderTypeID != 2">
                        <span class="font-weight-bold" v-if="value.MaxElapse >= 0" style="font-size: 1rem;">
                            +{{value.MaxElapse}} Min
                        </span>
                        <span class="font-weight-bold" v-if="value.DueTime" style="font-size: 1rem;">
                            (DUE {{value.DueTime}})
                        </span>
                    </span>
                    <span v-if="value.OrderTypeID == 2" style="width:2rem; font-size: 1rem;">
                        

                    </span>
                </div>
                
            </div>
            <div class="ticket-body p-2">
                <template v-if="value.Items && getFoodsByKds(value.Items).length">
                    <div class="d-flex flex-row my-2" v-for="food in getFoodsByKds(value.Items)">
                        <div
                            @click="changeStatusItem(food)"
                            :class="{'new-item': food.OrderDetailStatusID == 1,
                         'ready-serve-item': food.OrderDetailStatusID == 4 || food.OrderDetailStatusID == 3,
                          'confirm-item-food':  food.FoodID != 0 && food.OrderDetailStatusID !== 3 && food.OrderDetailStatusID !== 4,
                          'confirm-item-drink': food.DrinkID != 0 && food.OrderDetailStatusID !== 3 && food.OrderDetailStatusID !== 4,
                          'cursor-pointer': food.OrderDetailStatusID !== 1
                          }"
                        >
                        
                          <div class="d-flex">
                            <span style="font-size: 1.1rem;">{{food.Quantity}}x</span>
                            <span
                                v-if="food.Course"
                                class="ml-2">{{food.Course}}</span>
                              <span style="padding-left: 15px">
                                <span style="font-weight:bold; font-size: 1.3rem;">
                                  {{food.ItemName}}
                                </span>
                                
                                <span v-if="food.ItemName_SecondLang !== ' ' && value.AllowSecondLang" style="font-weight:bold; color:#78909C" >{{food.ItemName_SecondLang}} </span>
                                <template v-if="food.OrderDetailStatusID == 3">
                                    <font-awesome-icon icon="check" class="small align-middle" />
                                </template>
                                 <template v-if="food.OrderDetailStatusID == 4">
                                    <font-awesome-icon icon="check" class="small align-middle" />
                                    <font-awesome-icon icon="check" class="small align-middle" />
                                </template>
                                <div class="text-danger">
                                    <div v-if="food.PriceComment" style="color: #f9b300;font-size: 1.1rem !important;">{{food.PriceComment}} <span v-if="food.PriceComment_SecondLang && value.AllowSecondLang"  style="font-weight:bold; color:#78909C">{{food.PriceComment_SecondLang}}</span></div>
                                    <div v-if="food.Modifiers" style="font-size: 1rem !important;">{{food.Modifiers}}</div>
                                    <div v-if="food.Modifiers_SecondLang && value.AllowSecondLang"  style="color: #78909C; font-size: 1rem !important;">{{food.Modifiers_SecondLang}}</div>
                                    <div v-if="food.ItemDescription != ' '&& food.ItemDescription != '' && food.ItemDescription " style="color: #f9b300; font-size: 1rem !important;">Note: {{" "+food.ItemDescription}}</div>
                                   
                                </div>
                        </span>
                          </div>
                        </div>
                    </div>
                    

                </template>
                <template v-else>
                    <no-item title="none"/>
                </template>
              <div class="mb-0 text-danger font-weight-bold" v-if="value.OrderDescription && value.OrderDescription !=''">
                Note : {{value.OrderDescription}}
              </div>
            </div>
        </b-overlay>
        <b-btn @click="Acknowledge" v-if="!value.TicketTabAcknowledged" variant="font-weight-bold" class="text-danger" style="width:50%; background-color:#FFFF00; position:absolute; bottom:0.5rem; right:0.9rem; border-radius:0 !important; color:#37474F !important; opacity:0.8">ACKnowledge</b-btn>

    </div>
</template>

<script>
import NoItem from "../../shared/noItem";
    export default {
        name: "ticketItem",
        components: {NoItem},
        props: {
            value: {
                required: true,
                type: Object
            },
            kds: {
                required: false
            },
            orderId: {
                required: true,
                type: [Number, String]
            },
            ticketType: {
                type: String
            },
            currentKDS: {
                required: false,
                type: Number
            },
            kdsList: {
                required: false,
                type: Array
            },
           
        },
        data () {
            return {
                progressing: false,
                ticketTimer:null,
            }
        },
        
        methods: {
            Acknowledge(){
                
                let model =  {
                    UserID:localStorage.getItem("userID"),
                    RestaurantID:localStorage.getItem('selectedRestaurant'),
                    OrderID:this.value.OrderID
                }
                this.$api.getRestaurant.UpdateTicketTabAcknowledged(model).then(res=>{
                    if(res.success)
                        this.$emit('refresh')
                    else
                    this.$showError("Error occurred!! ", res.message)
                })
            },
            progressOrderStatus(){
                if(this.value.OrderStatusID == 4){
                    return 
                }
                
                if(this.kdsList.length == 1 || this.currentKDS == -1){
                    this.progressing = true
                    const modal = {
                        OrderID:this.orderId,
                        OrderStatusID:this.value.OrderStatusID + 1,
                        RestaurantID:localStorage.getItem("selectedRestaurant")
                    }
                    this.$api.getRestaurant.UpdateOrderStatus(modal).then((res)=>{
                        if(res.success){
                            this.$emit('refreshOneItemOnly', this.orderId)
                        }else{
                            this.$showError("Error occurred while updating order status!!!")
                        }
                        this.progressing=false
                    })
                
                }else if(this.kdsList.length > 1){
                   
                    
                    const modal = {
                        IKey:this.orderId,
                        OrderID:this.orderId,
                        OrderStatusID:this.value.OrderStatusID + 1,
                        RestaurantID:localStorage.getItem("selectedRestaurant"),
                        UserID:localStorage.getItem("userID"),
                        CancelReason: "",
                        KDS:this.currentKDS
                    }
                    
                   
               
                    this.progressing = true
                    this.$api.getRestaurant.UpdateOrderDetailsStatus(modal).then((res)=>{
                        if(res.success){
                            this.$emit('refreshOneItemOnly', this.orderId)
                        }else{
                            this.$showError("Error occurred while updating order status!!!")
                        }
                        this.progressing=false
                    })
                }


                    
                
            },
            headerClicked(){
                
                if (this.clickTimer == null) {
                    this.clickTimer = setTimeout( ()=> {
                        this.clickTimer = null;
                    }, 250)
                } else {
                    clearTimeout(this.clickTimer);
                    this.clickTimer = null;
                    this.progressOrderStatus()
                }
                
            },
            getFoodsByKds (items) {
                if (!this.kds) {
                    return items
                } else {
                    return items.filter(food => food.KDSid === this.kds)
                }
            },
            changeStatusItem (food) {
                // IKey
                if (food.OrderDetailStatusID !== 1) {
                    if (food.OrderDetailStatusID === 2) {
                        //3
                        this.updateStatus(food.OrderDetailID, 3)
                    } else if (food.OrderDetailStatusID === 3) {
                        //4
                        this.updateStatus(food.OrderDetailID, 4)
                    } else if (food.OrderDetailStatusID === 4) {
                        //2
                        this.updateStatus(food.OrderDetailID, 2)
                    }
                }
            },
            updateStatus (IKey, OrderStatusID) {
                const model = {
                    IKey,
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId,
                    OrderStatusID
                }
                this.progressing = true
                return this.$api.getRestaurant.UpdateOrderDetailsStatus(model, true).then(res => {
                    this.progressing = false
                    if (res.success) {
                        this.$emit('refresh')
                        
                    } else {
                        this.progressing = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.progressing = false
                })
            },
            UpdateOrderStatus (OrderID, OrderStatusID) {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID,
                    OrderStatusID
                }
                this.loading = true
                this.$api.getRestaurant.UpdateOrderStatus(object).then(res => {
                    this.progressing = false
                    if (res.success) {
                        this.$emit('refresh')
                    } else {
                        this.progressing = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.progressing = false
                })
            },
            setTicketHeaderClass (items, time, OrderTypeID, OrderStatusID) {
                const allNew = items.every(item => item.OrderStatus === 1)
                const atLeaseNotNew = items.find(item => item.OrderStatus !== 1)
                const allReady = items.every(item => item.OrderStatus === 3)
                const allServed = items.every(item => item.OrderStatus === 4)
                const allServedOrReady = allReady || allServed
                if (this.ticketType === 'complete') {
                  if (OrderStatusID !== 4) {
                      if (OrderTypeID !== 2 && time <= 5) {
                          if (time > 0 && time <= 5) {
                              return 'warning-header'
                          } else if (time < 0) {
                              return 'danger-header text-white'
                          }
                      } else {
                          if (OrderStatusID === 1 || OrderStatusID === 2) {
                              return 'confirm-header'
                          } else {
                              return 'not-prepair-header'
                          }
                      }
                  } else {
                      return 'default-header'
                  }
                }
                else {
                    if (allNew) {
                        return 'all-new-header'
                    } else {
                        if (atLeaseNotNew) {
                            if (OrderTypeID !== 2) {
                                if ((time >= 0 && time <= 5)) {
                                    return 'warning-header'
                                } else if (time < 0) {
                                    return 'danger-header text-white'
                                } else if (time > 5) {
                                    return 'not-prepair-header'
                                }
                            } else {
                                return 'not-prepair-header'
                            }
                        }
                    }
                }
                return ''
                // if (allNew) {
                //     return 'all-new-header'
                // } else if ((allReady || allServed) && this.value.OrderStatusID === 4) {
                //     return 'default-header'
                // } else if (atLeaseNotNew && !(allReady || allServed)){
                //     if (OrderTypeID !== 2) {
                //         if ((time >=0 && time <= 6)) {
                //             return 'warning-header'
                //         } else if (time < 0) {
                //             return 'danger-header text-white'
                //         } else if (time > 6) {
                //             return 'not-prepair-header'
                //         }
                //     }
                //     else {
                //         return 'not-prepair-header'
                //     }
                // } else if (this.ticketType === 'complete' && this.value.OrderStatusID != 4) {
                //     return 'confirm-header'
                // }
            },
            updateDetails () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId
                }
                return this.$api.getRestaurant.GetRestaurantOrderDetail(object).then(res => {
                    if (res.success) {
                        return res.results
                    }
                })
            },
            isAllNew (items) {
                return items.every(item => item.OrderStatus === 1)
            }
        }
    }
</script>

<style scoped>
    
    .new-item{
        color: lightskyblue;
    }
    .ready-serve-item{
        color: #8191a9;
    }
    .confirm-item-food{
        color: black;
        font-weight: bold;
    }
    .confirm-item-drink {
        color: blue;
        font-weight: bold;
    }

    .sticky-footer{
      position: sticky;
      top: 0;
      z-index: 950;
    }
    .ticket-header{
        cursor: pointer;
    }
</style>
